import { useEffect, useState } from 'react';

const BACKEND = 'https://lobster-app-sd3s8.ondigitalocean.app';

export function useAnalysisPolling(analysisJobId, token, { onComplete, onError }) {
  const [isPolling, setIsPolling] = useState(true);

  useEffect(() => {
    if (!analysisJobId || !isPolling) return;
    let handle;

    const poll = async () => {
      try {
        console.log('Polling analysis job status:', `${BACKEND}/api/job/${analysisJobId}`);
        const res = await fetch(`${BACKEND}/api/job/${analysisJobId}`, {
          headers: { Authorization: token }
        });

        console.log('Analysis polling status:', res.status);
        console.log('Analysis polling headers:', Object.fromEntries(res.headers.entries()));

        if (!res.ok) {
          const txt = await res.text();
          console.log('Analysis polling error response:', txt);
          if (res.status === 404) throw new Error('not_found');
          throw new Error(`HTTP ${res.status}: ${txt}`);
        }

        const ct = res.headers.get('Content-Type') || '';
        if (!ct.includes('application/json')) {
          const html = await res.text();
          console.log('Analysis polling non-JSON response:', html);
          throw new Error(`Expected JSON but got HTML: ${html}`);
        }

        const { status, result } = await res.json();
        console.log('Analysis polling response:', { status, result });

        if (status === 'completed') {
          onComplete(result);
          setIsPolling(false); // Stop polling
        } else if (status === 'failed') {
          throw new Error('Analysis failed');
        }
      } catch (err) {
        console.error('Analysis polling error:', err);
        setIsPolling(false); // Stop polling on error
        onError(err.message || err);
      }
    };

    poll();
    handle = setInterval(poll, 10000);

    return () => clearInterval(handle);
  }, [analysisJobId, token, onComplete, onError, isPolling]);

  return { isPolling };
}